import { render } from "./VideoWallPresetSelect.vue?vue&type=template&id=4daaf529&ts=true"
import script from "./VideoWallPresetSelect.vue?vue&type=script&lang=ts"
export * from "./VideoWallPresetSelect.vue?vue&type=script&lang=ts"

import "./VideoWallPresetSelect.vue?vue&type=style&index=0&id=4daaf529&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__